import { Injector } from '@angular/core';

export class LocatorService {
  public static injector: Injector;
}
